const initialState = {
    data: null,
    response: null,
    message: null,

};

const initialStateForMonth = {
    data: null,
    response: null,
    message: null,

};

export function fyReducer(state = initialState, action) {
  
    const { type, data } = action;
    

    switch (type) {
        case "FY_FETCH_SUCCESS":
            return {
                ...state,
                status: 200,
                data: data,
                message: "Success",
                
            };
        case "FY_FETCH_FAILURE": {
            return {
                ...state,
                status: 400,
                data: [],
                message: "Something Went Wrong",

            };
        }

        default:
            return state;
    }
}

export function fymReducer(state = initialStateForMonth, action) {
  
    const { type, data } = action;
    

    switch (type) {
        case "FYM_FETCH_SUCCESS":
            return {
                ...state,
                status: 200,
                data: data,
                message: "Success",
                
            };
        case "FYM_FETCH_FAILURE": {
            return {
                ...state,
                status: 400,
                data: [],
                message: "Something Went Wrong",

            };
        }

        default:
            return state;
    }
}
